import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import type { SingleSparkStepResponse } from 'types/SparkStep';
import type { SparkStepAttribute } from 'types/SparkStep';
import { useUpdateSparkStepHelper } from 'stores/sparkBuilderStore';

type mutationVariables = Partial<SparkStepAttribute> & {
  stepID: string | undefined;
};

export function useUpdateSparkStep(sparkID: string | null | undefined) {
  const queryClient = useQueryClient();
  const updateSparkStepHelper = useUpdateSparkStepHelper();
  const updateSparkStep = (attributes: mutationVariables) => {
    if (!sparkID) {
      return Promise.reject('Spark ID can not be null');
    }

    const { stepID, ...rest } = attributes;
    if (!stepID) {
      return Promise.reject('spark step ID can not be null');
    }

    const body = {
      data: {
        id: stepID,
        type: 'sparkSteps',
        attributes: {
          ...rest,
          sparkID: sparkID,
        },
      },
    };
    return fetchWrapper<SingleSparkStepResponse>({
      url: `sparkSteps/${stepID}`,
      method: 'PATCH',
      body: body,
    });
  };

  return useMutation('updateSparkSteps', updateSparkStep, {
    onMutate: (stepMutateVariable) => {
      updateSparkStepHelper.onMutate(
        stepMutateVariable,
        stepMutateVariable.stepID || ''
      );
    },
    onSuccess: async (data) => {
      if (data.data) {
        updateSparkStepHelper.onSuccess(data.data);
      }
      await queryClient.invalidateQueries(['SparkStepParameters']);
    },
    onError: (error) => {
      updateSparkStepHelper.onError();
      if (error instanceof Error) {
        toastr.error(`failed to update Spark Step: ${error.message}`);
        return;
      }
    },
  });
}
